import { useMemo } from 'react';
import { encode } from 'uqr';

/** Caminho SVG com um quadrado por módulo escuro (um `path` só, sem `innerHTML`). Testado em `tests/conta-fase2.test.ts`. */
export function caminhoQr(texto: string): { tamanho: number; d: string } {
  const qr = encode(texto, { ecc: 'M', border: 0 });
  let d = '';
  qr.data.forEach((linha, y) =>
    linha.forEach((escuro, x) => {
      if (escuro) d += `M${x} ${y}h1v1h-1z`;
    }),
  );
  return { tamanho: qr.size, d };
}

/**
 * Fase 2 (W4): código QR do `otpauth://`, gerado no navegador (sem serviço externo). Módulo escuro sobre fundo claro nos dois
 * temas (o leitor de alguns aplicativos não lê QR invertido): no escuro, fundo `tinta-1` e módulos `fundo`; no claro, fundo
 * `sup-1` e módulos `tinta-1`. A margem clara em volta (padding) é a zona de silêncio do QR.
 */
export function CodigoQr({ texto, rotulo, tema }: { texto: string; rotulo: string; tema: 'escuro' | 'claro' }) {
  const { tamanho, d } = useMemo(() => caminhoQr(texto), [texto]);
  return (
    <div className={`w-fit rounded-xl border border-borda p-4 ${tema === 'escuro' ? 'bg-tinta-1' : 'bg-sup-1'}`}>
      <svg role="img" aria-label={rotulo} viewBox={`0 0 ${tamanho} ${tamanho}`} className={`size-44 ${tema === 'escuro' ? 'fill-fundo' : 'fill-tinta-1'}`} shapeRendering="crispEdges">
        <path d={d} />
      </svg>
    </div>
  );
}
